// extracted by mini-css-extract-plugin
export default {"inputControl":"Textarea_inputControl__mdvZx","label":"Textarea_label__QQFgv","requiredMark":"Textarea_requiredMark__Rdx9B","inputField":"Textarea_inputField__e-pw7"};